import React, { Component } from 'react';

import Helmet from './Helmet';

export default class SignInHelmet extends Component {
  render() {
    return <Helmet title="Canny" meta={[{ name: 'robots', content: 'noindex,follow' }]} />;
  }
}
